import { useState } from 'react';
import type { Review } from '@/types';

export default function ReviewList({ reviews }: { reviews: Review[] }) {
  const [expanded, setExpanded] = useState<string | null>(reviews[0]?.id ?? null);

  return (
    <section className="mt-12">
      <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
        <i className="ri-quill-pen-line text-accent-600" aria-hidden="true" />
        影评精选
        <span className="font-label text-sm font-medium text-foreground-400">（{reviews.length} 篇）</span>
      </h2>

      <div className="mt-5 flex flex-col gap-4">
        {reviews.map((r) => {
          const isOpen = expanded === r.id;
          return (
            <article
              key={r.id}
              className="rounded-lg border border-background-200/80 bg-background-50 p-5"
            >
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-user-3-line" aria-hidden="true" />
                  {r.author}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-calendar-line" aria-hidden="true" />
                  {r.date}
                </span>
                <span className="inline-flex items-center gap-1 text-accent-700">
                  <i className="ri-price-tag-3-line" aria-hidden="true" />
                  深度解析
                </span>
              </div>

              <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">{r.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{r.excerpt}</p>

              <div
                className={`grid transition-all duration-500 ${
                  isOpen ? 'grid-rows-[1fr] opacity-100 mt-3' : 'grid-rows-[0fr] opacity-0'
                }`}
              >
                <div className="overflow-hidden">
                  <div className="border-l-2 border-accent-300 pl-4 flex flex-col gap-3">
                    {r.content.map((p, i) => (
                      <p key={i} className="text-sm leading-loose text-foreground-700">
                        {p}
                      </p>
                    ))}
                  </div>
                </div>
              </div>

              <button
                type="button"
                onClick={() => setExpanded(isOpen ? null : r.id)}
                className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-accent-600 transition-colors cursor-pointer"
              >
                {isOpen ? '收起全文' : '阅读全文'}
                <i className={isOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} aria-hidden="true" />
              </button>
            </article>
          );
        })}
      </div>
    </section>
  );
}